import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ASSETS_PATH } from 'src/app/core/config';
import { EVENT_STATUS_TYPES } from 'src/app/core/models/enum.model';
import { Event } from 'src/app/core/models/event.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { EventService } from 'src/app/core/services/event.service';
import { FileService } from 'src/app/core/services/file.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-upsert-event',
  templateUrl: './upsert-event.component.html',
  styleUrls: ['./upsert-event.component.scss']
})
export class UpsertEventComponent implements OnInit {
  event = new Event();
  addEventForm: FormGroup;
  eventCategories = [];
  assetsPath = ASSETS_PATH;
  status_types = EVENT_STATUS_TYPES;

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private eventService: EventService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private fileService: FileService) { }

  ngOnInit(): void {
    this.getEventCategories();
    this.addEventForm = this.formBuilder.group({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(150)
      ]),
      description: new FormControl('', [
        Validators.required,
        Validators.maxLength(150)
      ]),
      location: new FormControl('', [
        Validators.required,
        Validators.maxLength(250)
      ]),
      status: new FormControl(null, [
        Validators.required
      ]),
      eventCategoryId: new FormControl(null, [
        Validators.required
      ]),
      startDate: new FormControl(null, [
        Validators.required
      ]),
      endDate: new FormControl(null, [
        Validators.required
      ]),
      applicationEndDate: new FormControl(null),
      isAvailableAllUser: new FormControl(false)
    });

    if (this.route.snapshot.params.id) {
      this.eventService.getEventById(this.route.snapshot.params.id).subscribe(response => {
        if (response.success) {
          this.event = response;
          console.log(response);
          this.addEventForm.controls['name'].setValue(this.event.name);
          this.addEventForm.controls['description'].setValue(this.event.description);
          this.addEventForm.controls['location'].setValue(this.event.location);
          this.addEventForm.controls['status'].setValue(this.event.status);
          this.addEventForm.controls['eventCategoryId'].setValue(this.event.eventCategoryId);
          this.addEventForm.controls['startDate'].setValue(this.event.startDate);
          this.addEventForm.controls['endDate'].setValue(this.event.endDate);
          this.addEventForm.controls['applicationEndDate'].setValue(this.event.applicationEndDate);
          this.addEventForm.controls['isAvailableAllUser'].setValue(this.event.isAvailableAllUser);
        }
      })
    }
  }

  getEventCategories() {
    this.eventService.getEventCategories().subscribe(response => {
      if (response.success){
        console.log(response)
        this.eventCategories = response.eventCategories; 
      }
    })
  }

  save() {
    if (this.addEventForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.addEventForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.addEventForm.value);

      this.event.name = data.name;
      this.event.description = data.description;
      this.event.location = data.location;
      this.event.status = data.status;
      this.event.eventCategoryId = data.eventCategoryId;
      this.event.startDate = data.startDate;
      this.event.endDate = data.endDate;
      this.event.applicationEndDate = data.applicationEndDate;
      this.event.isAvailableAllUser = data.isAvailableAllUser;

      console.log(this.event);

      if (this.event.id) {
        this.eventService.updateEvent(this.event).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Etkinlik güncellendi!', 'success')
            this.router.navigate(['/event-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }
      else {
        console.log(this.event);
        this.eventService.createEvent(this.event).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Etkinlik eklendi!', 'success')
            this.router.navigate(['/event-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }



    }
  }

  get f() {
    return this.addEventForm.controls;
  }

  onLocalFileChange(files: NgxFileDropEntry[]) {
    this.loadingService.setLoading(true);
    for (const f of files) {
      const fileEntry = f.fileEntry as FileSystemFileEntry;
      if (fileEntry.isFile) {
        fileEntry.file((file) => {
          this.fileService.uploadFile(file).subscribe(res => {
            if (res.success) {
              this.event.image = res.fileName;
            }
            this.loadingService.setLoading(false);
          });
        })
      }
    }
  }
  removeFile() {
    this.event.image = null;
  }

}
